import { render, staticRenderFns } from "./AddUpdateBank.vue?vue&type=template&id=49ff0a00&"
import script from "./AddUpdateBank.vue?vue&type=script&lang=js&"
export * from "./AddUpdateBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports